export const contact_info = {
  phone_display: '+1 (647) 812-0942',
  phone_link: '+16478120942',
  email: 'contact@fancycloud.ca',
  location: 'Our datacentre'
};
